__turbopack_context__.v({
  "columns": "EnterLayout-module__vTdFva__columns",
  "infoButton": "EnterLayout-module__vTdFva__infoButton",
  "main": "EnterLayout-module__vTdFva__main",
  "mainInner": "EnterLayout-module__vTdFva__mainInner",
  "mainInnerInTabControl": "EnterLayout-module__vTdFva__mainInnerInTabControl",
  "sidePanel": "EnterLayout-module__vTdFva__sidePanel",
  "sidePanelBackground_GREY": "EnterLayout-module__vTdFva__sidePanelBackground_GREY",
  "sidePanelBackground_TEAL": "EnterLayout-module__vTdFva__sidePanelBackground_TEAL",
  "sidePanelInner": "EnterLayout-module__vTdFva__sidePanelInner",
  "stepIcon": "EnterLayout-module__vTdFva__stepIcon",
  "stepIconArea": "EnterLayout-module__vTdFva__stepIconArea",
  "stepIntroText": "EnterLayout-module__vTdFva__stepIntroText",
  "stepName": "EnterLayout-module__vTdFva__stepName",
  "tooltipContent": "EnterLayout-module__vTdFva__tooltipContent",
  "tooltipStepIcon": "EnterLayout-module__vTdFva__tooltipStepIcon",
});
